<div class="remittance-container">
  <div class="d-flex flex-column gap-1">
    <span i18n class="remittance-label">R-{{ activeRemittance?.id | leadingZero : 8 }}</span>
    <div class="employer-meta d-flex gap-1">
      <div class="employer-name">{{ activeRemittance?.employerName }}</div>
      <div class="dot">•</div>
      <div class="employer-id">{{ activeRemittance?.employerId | leadingZero : 8 }}</div>
    </div>
  </div>
  <div class="remittance-details d-flex gap-3 my-auto">
    <div class="remittance-statuses d-flex gap-3">
      <div class="d-flex gap-2">
        <span class="status-label" i18n>Status:</span>
        <app-status-pill [statusPill]="activeRemittance?.remittanceStatusPill" />
      </div>
      <div class="d-flex gap-2">
        <span class="status-label" i18n>Payment:</span>
        <app-status-pill [statusPill]="activeRemittance?.remittancePaymentStatusPill" />
      </div>
    </div>
    <app-tertiary-button
      (buttonClicked)="goToRemittance()"
      [size]="BaseButtonSizeEnum.sm"
      [rightIconSrc]="'assets/icons/blue/ExternalLink.svg'"
      i18n>
      View
    </app-tertiary-button>
  </div>
</div>
